module.exports = __webpack_public_path__ + "img/baumkontrolle-active.1d1a5a80.svg";